<template lang="pug">
div
    // only has 1 promotion per line item
    mixin discountV2(discount)
            .row.grand-total-amount(v-if="groupDiscountPerGroupItem(discount)")
                .col-xs-11.p-l-sm
                    small._500 {{ discount.discountName }}
                .col-xs-1.p-r-sm
                    small.pull-right._500 x{{ discount.discountQuantity }}

            div(v-for="lineItem in discount.groupLineItems")
                div(v-if="lineItem.itemType === 'cstore'")
                    .row
                        .col-xs-1
                            small {{ lineItem.taxShortName }}
                        .col-xs-5
                            small {{ lineItem.productName }}
                        .col-xs-2
                            small.pull-right @{{ lineItem.unitPrice.toFixed(2) }}
                        .col-xs-2
                            small.pull-right x{{ lineItem.quantity }}
                        .col-xs-2
                            small.pull-right {{ lineItem.amount.toFixed(2) }}
                    div(v-if="lineItem.totalDiscountPerItem !== 0")
                        .row
                            .col-xs-8
                                small.pull-right ({{ trans('receipt.discount') }}: {{ lineItem.totalDiscountPerItem.toFixed(2) }})
                        .row(v-if="lineItem.hasManualDiscount")
                            .col-xs-8
                                small.pull-right ({{ lineItem.manualDiscountName }}: {{ lineItem.totalManualDiscountPerItem.toFixed(2) }})
                        .row
                            .col-xs-8
                                small.pull-right ({{ trans('receipt.price_after_discount') }}: {{ lineItem.totalAmount.toFixed(2) }})

                div(v-else)
                    .row
                        .col-xs-1
                            small {{ lineItem.taxShortName }}
                        .col-xs-5
                            small {{ lineItem.productName }} (Pump {{ lineItem.fuelDetails.pump_id }})
                        .col-xs-2
                            small.pull-right {{ lineItem.unitPrice.toFixed(3) }}
                        .col-xs-4
                            small.pull-right {{ lineItem.amount.toFixed(2) }}
                    .row
                        .col-xs-1
                        .col-xs-5
                            small {{ lineItem.quantity.toFixed(3) }} litre
                        .col-xs-2
                            small.pull-right {{ getCurrency() }} / L
                    div(v-if="lineItem.totalDiscountPerItem !== 0")
                        .row
                            .col-xs-8
                                small.pull-right ({{ trans('receipt.discount') }}: {{ lineItem.totalDiscountPerItem.toFixed(2) }})
                        .row(v-if="lineItem.hasManualDiscount")
                            .col-xs-8
                                small.pull-right ({{ lineItem.manualDiscountName }}: {{ lineItem.totalManualDiscountPerItem.toFixed(2) }})
                        .row
                            .col-xs-8
                                small.pull-right ({{ trans('receipt.price_after_discount') }}: {{ lineItem.totalAmount.toFixed(2) }})

    mixin fuel(fuel)
        .row(v-if="fuel")
            .col-xs-1
                small {{ fuel.taxShortName }}
            .col-xs-5
                small {{ fuel.name }} (Pump {{ fuel.fuel_details.pump_id }})
            .col-xs-2
                small.pull-right {{ fuel.unit_price.toFixed(3) }}
            .col-xs-4
                small.pull-right {{ fuel.amount.toFixed(2) }}
        .row
            .col-xs-1
            .col-xs-5
                small {{ fuel.quantity.toFixed(3) }} litre
            .col-xs-2
                small.pull-right {{ getCurrency() }} / L
        .row(v-if="fuel.hasManualDiscount")
            .row
                .col-xs-8
                    small.pull-right ({{ fuel.applied_discounts[0].discount.name }}: {{ fuel.applied_discounts[0].discount.applied_amount.toFixed(2) }})
            .row
                .col-xs-8
                    small.pull-right ({{ trans('receipt.price_after_discount') }}: {{ fuel.total_amount.toFixed(2) }})

    mixin product(product)
        .row(v-if="product")
            .col-xs-1
                small {{ product.taxShortName }}
            .col-xs-5
                small {{ product.productName }}
            .col-xs-2
                small.pull-right @{{ product.unitPrice.toFixed(2) }}&nbsp;
            .col-xs-2
                small.pull-right x{{ product.quantity }}
            .col-xs-2
                small.pull-right {{ product.amount.toFixed(2) }}
        div(v-if="product.hasManualDiscount && !isRefund")
            .row
                .col-xs-8
                    small.pull-right ({{ product.discount.name }}: {{ product.discount.applied_amount.toFixed(2) }})
            .row
                .col-xs-8
                    small.pull-right ({{ trans('receipt.price_after_discount') }}: {{ product.totalAmount.toFixed(2) }})
        div(v-if="product.totalDiscount !== 0 && isRefund")
            .row
                .col-xs-8
                    small.pull-right ({{ product.hasManualDiscount ? product.discount.name : 'Discount' }}: {{ product.totalDiscount.toFixed(2) }})
            .row
                .col-xs-8
                    small.pull-right ({{ trans('receipt.price_after_discount') }}: {{ product.totalAmount.toFixed(2) }})

    .row(v-if="cancelledItemContext && cancelProducts.length")
        .col-xs-12
            small.dark.block.text-center.m-b-sm {{ trans('receipt.cancelled_items') }}

            div(v-for="product in cancelProducts")
                +product(product)

    .row(v-if="!cancelledItemContext && (discountLineItems.length || products.length || fuels.length)")
        .col-xs-12
            div(v-if="isSale || isVoid")
                small.dark.block.text-center.m-y-sm {{ trans('receipt.purchased_items') }}

            div(v-else-if="isRefund")
                small.dark.block.text-center.m-y-sm {{ trans('receipt.refunded_items') }}

            div(v-for="fuel in fuels")
                +fuel(fuel)

            div(v-for="product in products")
                +product(product)

            div(v-for="discount in groupDiscounts" v-if="!isRefund")
                +discountV2(discount) 

    .row
        .col-xs-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import StoreMixin from './store-mixin';
import { mapGetters } from 'vuex';
import formattedCurrencyMixin from '@js/mixins/formatted-currency';
import receiptFeatureFlagMixin from './receipt-feature-flag-mixin';

export default {
    mixins: [
        receiptMixin,
        StoreMixin,
        formattedCurrencyMixin,
        receiptFeatureFlagMixin,
    ],

    computed: {
        ...mapGetters('transactionPostgres', [
            'discountLineItems',
            'products',
            'fuels',
            'cancelProducts',
            'isSale',
            'isRefund',
            'isVoid',
            'groupDiscounts',
            'cancelledItemContext',
        ]),
    },

    methods: {
        discountTotal(discounts) {
            return discounts
                .map(d => {
                    return parseFloat(d.applied_amount);
                })
                .reduce((a, b) => a + b, 0)
                .toFixed(2);
        },

        discountFuelPrice(item) {
            return (item.net_amount / item.quantity).toFixed(3);
        },

        shouldShowDiscount(discountLineItems, itemKey, discount) {
            if (itemKey === 0) {
                let d = discountLineItems[itemKey].applied_discounts.filter(
                    appliedDiscount => {
                        return (
                            discount.discount_id === appliedDiscount.discount_id
                        );
                    },
                );

                if (d.length) {
                    return true;
                }
            }

            return false;
        },

        itemAppliedDiscountPerLineItem(item) {
            if (this.hasReceiptCapillaryOrderLevel) {
                const itemAppliedDiscounts = item.applied_discounts.filter(
                    discount => {
                        return (
                            discount.discount.discount_source !==
                            'SHELL_CAPILLARY'
                        );
                    },
                );

                return {
                    itemAppliedDiscounts,
                    perLineItem: false,
                };
            }

            const itemAppliedDiscounts = item.applied_discounts;

            return {
                itemAppliedDiscounts,
                perLineItem: true,
            };
        },

        groupDiscountPerGroupItem(discount) {
            return !(
                this.hasReceiptCapillaryOrderLevel &&
                discount.discountSource === 'SHELL_CAPILLARY'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.voided {
    font-size: 14px;
    vertical-align: middle;
}
.grand-total-amount {
    border: 1px solid #666;
    border-radius: 5px;
    margin-left: 0;
    margin-right: 0;
}
</style>
